import { render, staticRenderFns } from "./promotion-strip.vue?vue&type=template&id=ac62255e&scoped=true&"
import script from "./promotion-strip.ts?vue&type=script&lang=ts&"
export * from "./promotion-strip.ts?vue&type=script&lang=ts&"
import style0 from "./promotion-strip.vue?vue&type=style&index=0&id=ac62255e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac62255e",
  null
  
)

export default component.exports